const parseTimestamp = (value) => {
    if (!value) return NaN;
    const normalized = String(value).replace(/(\.\d{3})\d+/, '$1');
    return new Date(normalized).getTime();
};

export const getCorrectedNow = () => (
    window.socketService ? window.socketService.getCorrectedNow() : Date.now()
);

export const getConversationCountdownEndTime = (conversation, now = getCorrectedNow()) => {
    const appliedAt = conversation?.processing_delay_applied_at;
    const appliedSeconds = Number(conversation?.processing_delay_applied_seconds);

    if (appliedAt && Number.isFinite(appliedSeconds) && appliedSeconds > 0) {
        const startTime = parseTimestamp(appliedAt);
        if (Number.isFinite(startTime)) {
            return startTime + (appliedSeconds * 1000);
        }
    }

    const startsIn = parseInt(String(conversation?.processing_starts_in ?? 0), 10);
    if (Number.isFinite(startsIn) && startsIn > 0) {
        return now + (startsIn * 1000);
    }

    return 0;
};

export const getRemainingCountdownSeconds = (endTime, now = getCorrectedNow(), bufferMs = 0) => {
    if (!endTime) return 0;
    return Math.max(0, Math.ceil((endTime - now + bufferMs) / 1000));
};
